export const roles = {
  paging: { total: 29, count: 10, totalPages: 3, currentPage: 1 },
  roles: [
    {
      id: 33,
      role: 'ACH Admin',
      description: 'ACH portal full access',
      modules: [
        {
          id: 14,
          name: 'Loyalty',
          description: 'Loyalty',
          order: 4,
          roleModulePermissions: [
            {
              id: 12,
              permission: 'EDIT_LOYALTY_OFFER',
              description: 'Edit Loyalty Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 13,
              permission: 'DISTRIBUTE_LOYALTY_OFFERS',
              description: 'Distribute Loyalty Offers',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 11,
              permission: 'VIEW_LOYALTY_OFFER',
              description: 'View Loyalty Offers',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 14,
              permission: 'DELETE_LOYALTY_OFFER',
              description: 'Delete Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 10,
              permission: 'CREATE_LOYALTY_OFFER',
              description: 'Create Loyalty Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 27,
          name: 'Roles',
          description: 'Roles',
          order: 24,
          roleModulePermissions: [
            {
              id: 49,
              permission: 'EDIT_ROLE',
              description: 'Edit Role',
              moduleID: 27,
              active: true,
              deleted: false,
            },
            {
              id: 50,
              permission: 'DELETE_ROLE',
              description: 'Delete Role',
              moduleID: 27,
              active: true,
              deleted: false,
            },
            {
              id: 47,
              permission: 'CREATE_ROLE',
              description: 'Create Role',
              moduleID: 27,
              active: true,
              deleted: false,
            },
            {
              id: 48,
              permission: 'VIEW_ROLE',
              description: 'View Roles',
              moduleID: 27,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 11,
          name: 'Campaign',
          description: 'Campaign',
          order: 2,
          roleModulePermissions: [
            {
              id: 15,
              permission: 'CREATE_CAMPAIGN',
              description: 'Create Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 16,
              permission: 'VIEW_CAMPAIGN',
              description: 'View Campaigns',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 17,
              permission: 'EDIT_CAMPAIGN',
              description: 'Edit Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 18,
              permission: 'DELETE_CAMPAIGN',
              description: 'Delete Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 24,
          name: 'Group',
          description: 'Group',
          order: 21,
          roleModulePermissions: [
            {
              id: 63,
              permission: 'CREATE_GROUP',
              description: 'Create Group',
              moduleID: 24,
              active: true,
              deleted: false,
            },
            {
              id: 64,
              permission: 'VIEW_GROUP',
              description: 'View Group',
              moduleID: 24,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 19,
              permission: 'VIEW_DASHBOARD',
              description: 'View Dashboard',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 75,
              permission: 'VIEW_ORDERS',
              description: 'View Orders',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 13,
          name: 'Offers',
          description: 'Offers',
          order: 3,
          roleModulePermissions: [
            {
              id: 6,
              permission: 'VIEW_OFFER',
              description: 'View Offers',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 5,
              permission: 'CREATE_OFFER',
              description: 'Create Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 9,
              permission: 'DELETE_OFFER',
              description: 'Delete Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 8,
              permission: 'DISTRIBUTE_OFFERS',
              description: 'Distribute Offers',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 7,
              permission: 'EDIT_OFFER',
              description: 'Edit Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 10,
          name: 'Program',
          description: 'Program',
          order: 2,
          roleModulePermissions: [
            {
              id: 28,
              permission: 'CREATE_PROGRAM',
              description: 'Create Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 29,
              permission: 'VIEW_PROGRAM',
              description: 'View Programs',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 31,
              permission: 'DELETE_PROGRAM',
              description: 'Delete Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 30,
              permission: 'EDIT_PROGRAM',
              description: 'Edit Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 26,
          name: 'Users',
          description: 'Users',
          order: 23,
          roleModulePermissions: [
            {
              id: 44,
              permission: 'VIEW_USER',
              description: 'View Users',
              moduleID: 26,
              active: true,
              deleted: false,
            },
            {
              id: 43,
              permission: 'CREATE_USER',
              description: 'Create User',
              moduleID: 26,
              active: true,
              deleted: false,
            },
            {
              id: 45,
              permission: 'EDIT_USER',
              description: 'Edit User',
              moduleID: 26,
              active: true,
              deleted: false,
            },
            {
              id: 46,
              permission: 'DELETE_USER',
              description: 'Delete User',
              moduleID: 26,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 42,
          name: 'ACH Portal',
          description: 'ACH Portal',
          order: 31,
          roleModulePermissions: [
            {
              id: 127,
              permission: 'ACH_PORTAL_VIEW_TRANSACTION_HISTORY',
              description: 'ACH Portal View Transaction History',
              moduleID: 42,
              active: true,
              deleted: false,
            },
            {
              id: 125,
              permission: 'ACH_PORTAL_VIEW_POOL_ACCOUNT',
              description: 'ACH Portal View Pool Account',
              moduleID: 42,
              active: true,
              deleted: false,
            },
            {
              id: 124,
              permission: 'ACH_PORTAL_ACCESS',
              description: 'ACH Portal Access',
              moduleID: 42,
              active: true,
              deleted: false,
            },
            {
              id: 126,
              permission: 'ACH_PORTAL_ENROLL_LOCATION',
              description: 'ACH Portal Enroll Location',
              moduleID: 42,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 3,
              permission: 'EDIT_MESSAGE',
              description: 'Edit Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 2,
              permission: 'VIEW_MESSAGE',
              description: 'View Messages',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 4,
              permission: 'DELETE_MESSAGE',
              description: 'Delete Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
      ],
      active: true,
      deleted: false,
    },
    {
      id: 34,
      role: 'ACH User',
      description: 'All ACH portal access excluding pool account access',
      modules: [
        {
          id: 11,
          name: 'Campaign',
          description: 'Campaign',
          order: 2,
          roleModulePermissions: [
            {
              id: 17,
              permission: 'EDIT_CAMPAIGN',
              description: 'Edit Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 15,
              permission: 'CREATE_CAMPAIGN',
              description: 'Create Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 18,
              permission: 'DELETE_CAMPAIGN',
              description: 'Delete Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 16,
              permission: 'VIEW_CAMPAIGN',
              description: 'View Campaigns',
              moduleID: 11,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 19,
              permission: 'VIEW_DASHBOARD',
              description: 'View Dashboard',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 75,
              permission: 'VIEW_ORDERS',
              description: 'View Orders',
              moduleID: 9,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 10,
          name: 'Program',
          description: 'Program',
          order: 2,
          roleModulePermissions: [
            {
              id: 30,
              permission: 'EDIT_PROGRAM',
              description: 'Edit Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 29,
              permission: 'VIEW_PROGRAM',
              description: 'View Programs',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 28,
              permission: 'CREATE_PROGRAM',
              description: 'Create Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 42,
          name: 'ACH Portal',
          description: 'ACH Portal',
          order: 31,
          roleModulePermissions: [
            {
              id: 126,
              permission: 'ACH_PORTAL_ENROLL_LOCATION',
              description: 'ACH Portal Enroll Location',
              moduleID: 42,
              active: true,
              deleted: false,
            },
            {
              id: 127,
              permission: 'ACH_PORTAL_VIEW_TRANSACTION_HISTORY',
              description: 'ACH Portal View Transaction History',
              moduleID: 42,
              active: true,
              deleted: false,
            },
            {
              id: 124,
              permission: 'ACH_PORTAL_ACCESS',
              description: 'ACH Portal Access',
              moduleID: 42,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 2,
              permission: 'VIEW_MESSAGE',
              description: 'View Messages',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 3,
              permission: 'EDIT_MESSAGE',
              description: 'Edit Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 4,
              permission: 'DELETE_MESSAGE',
              description: 'Delete Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
      ],
      active: true,
      deleted: false,
    },
    {
      id: 1,
      role: 'ADMIN',
      description: 'Admin Full Access',
      modules: [
        {
          id: 35,
          name: 'Survey',
          description: 'Survey',
          order: 9,
          roleModulePermissions: [
            {
              id: 89,
              permission: 'EDIT_SURVEY',
              description: 'Edit Survey',
              moduleID: 35,
              active: true,
              deleted: false,
            },
            {
              id: 88,
              permission: 'VIEW_SURVEY',
              description: 'View Survey',
              moduleID: 35,
              active: true,
              deleted: false,
            },
            {
              id: 91,
              permission: 'CREATE_SURVEY',
              description: 'Create Survey',
              moduleID: 35,
              active: true,
              deleted: false,
            },
            {
              id: 90,
              permission: 'DELETE_SURVEY',
              description: 'Delete Survey',
              moduleID: 35,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 37,
          name: 'Customers',
          description: 'Customers',
          order: 11,
          roleModulePermissions: [
            {
              id: 128,
              permission: 'MANAGE_CUSTOMER_SPECIAL_TAGS',
              description: 'Manage Special Tags (Incentivio only)',
              moduleID: 37,
              active: true,
              deleted: false,
            },
            {
              id: 96,
              permission: 'VIEW_CUSTOMER',
              description: 'View Customer',
              moduleID: 37,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 27,
          name: 'Roles',
          description: 'Roles',
          order: 24,
          roleModulePermissions: [
            {
              id: 50,
              permission: 'DELETE_ROLE',
              description: 'Delete Role',
              moduleID: 27,
              active: true,
              deleted: false,
            },
            {
              id: 49,
              permission: 'EDIT_ROLE',
              description: 'Edit Role',
              moduleID: 27,
              active: true,
              deleted: false,
            },
            {
              id: 48,
              permission: 'VIEW_ROLE',
              description: 'View Roles',
              moduleID: 27,
              active: true,
              deleted: false,
            },
            {
              id: 47,
              permission: 'CREATE_ROLE',
              description: 'Create Role',
              moduleID: 27,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 130,
              permission: 'VIEW_GUEST_JOURNEY',
              description: 'View Guest Journey',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 169,
              permission: 'EDIT_GUEST_JOURNEY_SETTINGS',
              description: 'Edit Guest Journey Settings',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 129,
              permission: 'VIEW_RECOMMENDATIONS',
              description: 'View Recommendations',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 75,
              permission: 'VIEW_ORDERS',
              description: 'View Orders',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 19,
              permission: 'VIEW_DASHBOARD',
              description: 'View Dashboard',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 150,
              permission: 'VIEW_SALES_SUMMARY',
              description: 'View Sales Summary',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 24,
          name: 'Group',
          description: 'Group',
          order: 21,
          roleModulePermissions: [
            {
              id: 63,
              permission: 'CREATE_GROUP',
              description: 'Create Group',
              moduleID: 24,
              active: true,
              deleted: false,
            },
            {
              id: 65,
              permission: 'EDIT_GROUP',
              description: 'Edit Group',
              moduleID: 24,
              active: true,
              deleted: false,
            },
            {
              id: 64,
              permission: 'VIEW_GROUP',
              description: 'View Group',
              moduleID: 24,
              active: true,
              deleted: false,
            },
            {
              id: 66,
              permission: 'DELETE_GROUP',
              description: 'Delete Group',
              moduleID: 24,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 38,
          name: 'Easy Order',
          description: 'Easy Order',
          order: 19,
          roleModulePermissions: [
            {
              id: 99,
              permission: 'VIEW_EASY_ORDER',
              description: 'View Easy Order',
              moduleID: 38,
              active: true,
              deleted: false,
            },
            {
              id: 100,
              permission: 'EDIT_EASY_ORDER',
              description: 'Edit Easy Order',
              moduleID: 38,
              active: true,
              deleted: false,
            },
            {
              id: 101,
              permission: 'DELETE_EASY_ORDER',
              description: 'Delete Easy Order',
              moduleID: 38,
              active: true,
              deleted: false,
            },
            {
              id: 102,
              permission: 'CREATE_EASY_ORDER',
              description: 'Create Easy Order',
              moduleID: 38,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 13,
          name: 'Offers',
          description: 'Offers',
          order: 3,
          roleModulePermissions: [
            {
              id: 9,
              permission: 'DELETE_OFFER',
              description: 'Delete Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 7,
              permission: 'EDIT_OFFER',
              description: 'Edit Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 5,
              permission: 'CREATE_OFFER',
              description: 'Create Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 8,
              permission: 'DISTRIBUTE_OFFERS',
              description: 'Distribute Offers',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 6,
              permission: 'VIEW_OFFER',
              description: 'View Offers',
              moduleID: 13,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 43,
          name: 'Captcha',
          description: 'Captcha',
          order: 0,
          roleModulePermissions: [
            {
              id: 132,
              permission: 'ENABLE_CAPTCHA',
              description: 'Enable Captcha',
              moduleID: 43,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 39,
          name: 'Promo Code',
          description: 'Promo Code',
          order: 28,
          roleModulePermissions: [
            {
              id: 103,
              permission: 'CREATE_PROMO_CODE',
              description: 'Create Promo Code',
              moduleID: 39,
              active: true,
              deleted: false,
            },
            {
              id: 105,
              permission: 'VIEW_PROMO_CODE',
              description: 'View Promo Code',
              moduleID: 39,
              active: true,
              deleted: false,
            },
            {
              id: 104,
              permission: 'EDIT_PROMO_CODE',
              description: 'Edit Promo Code',
              moduleID: 39,
              active: true,
              deleted: false,
            },
            {
              id: 106,
              permission: 'DELETE_PROMO_CODE',
              description: 'Delete Promo Code',
              moduleID: 39,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 40,
          name: 'Gift Card',
          description: 'Gift Card',
          order: 29,
          roleModulePermissions: [
            {
              id: 116,
              permission: 'VIEW_GIFT_ANALYTICS',
              description: 'View Gift Analytics',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 120,
              permission: 'COMP_GIFT_CARD',
              description: 'Comp Gift Card',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 119,
              permission: 'COMP_ADD_VALUE_GIFT_CARD',
              description: 'Comp Add Value',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 113,
              permission: 'DEACTIVATE_GIFT_CARD',
              description: 'Deactivate Gift Card',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 112,
              permission: 'ACTIVATE_GIFT_CARD',
              description: 'Activate Gift Card',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 114,
              permission: 'IMPORT_GIFT_CARDS',
              description: 'Import Gift Cards',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 118,
              permission: 'RESEND_GIFT_CARD_EMAIL',
              description: 'Resend Gift Card Email',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 109,
              permission: 'VIEW_GIFT_CARD',
              description: 'View Gift Card',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 115,
              permission: 'GENERATE_GIFT_CARDS',
              description: 'Generate Gift Cards',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 110,
              permission: 'REMOVE_VALUE_GIFT_CARD',
              description: 'Remove Value From Gift Card',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 111,
              permission: 'RESET_BALANCE_GIFT_CARD',
              description: 'Reset Gift Card Balance',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 117,
              permission: 'VIEW_GIFT_CARD_POOL_REPORT',
              description: 'View Gift Card Pool Report',
              moduleID: 40,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 36,
          name: 'Survey Question',
          description: 'Survey Question',
          order: 10,
          roleModulePermissions: [
            {
              id: 95,
              permission: 'CREATE_SURVEY_QUESTION',
              description: 'Create Survey Question',
              moduleID: 36,
              active: true,
              deleted: false,
            },
            {
              id: 94,
              permission: 'DELETE_SURVEY_QUESTION',
              description: 'Delete Survey Question',
              moduleID: 36,
              active: true,
              deleted: false,
            },
            {
              id: 93,
              permission: 'EDIT_SURVEY_QUESTION',
              description: 'Edit Survey Question',
              moduleID: 36,
              active: true,
              deleted: false,
            },
            {
              id: 92,
              permission: 'VIEW_SURVEY_QUESTION',
              description: 'View Survey Question',
              moduleID: 36,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 11,
          name: 'Campaign',
          description: 'Campaign',
          order: 2,
          roleModulePermissions: [
            {
              id: 16,
              permission: 'VIEW_CAMPAIGN',
              description: 'View Campaigns',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 17,
              permission: 'EDIT_CAMPAIGN',
              description: 'Edit Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 18,
              permission: 'DELETE_CAMPAIGN',
              description: 'Delete Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 15,
              permission: 'CREATE_CAMPAIGN',
              description: 'Create Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 19,
          name: 'Store',
          description: 'Store',
          order: 12,
          roleModulePermissions: [
            {
              id: 26,
              permission: 'EDIT_STORE',
              description: 'Edit Store',
              moduleID: 19,
              active: true,
              deleted: false,
            },
            {
              id: 24,
              permission: 'CREATE_STORE',
              description: 'Create Store',
              moduleID: 19,
              active: true,
              deleted: false,
            },
            {
              id: 25,
              permission: 'VIEW_STORE',
              description: 'View Stores',
              moduleID: 19,
              active: true,
              deleted: false,
            },
            {
              id: 27,
              permission: 'DELETE_STORE',
              description: 'Delete Store',
              moduleID: 19,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 32,
          name: 'Store Ordering Setup',
          description: 'Store Ordering Setup',
          order: 13,
          roleModulePermissions: [
            {
              id: 80,
              permission: 'VIEW_STORE_ORDERING',
              description: 'View Store Ordering',
              moduleID: 32,
              active: true,
              deleted: false,
            },
            {
              id: 82,
              permission: 'DELETE_STORE_ORDERING',
              description: 'Delete Store Ordering',
              moduleID: 32,
              active: true,
              deleted: false,
            },
            {
              id: 81,
              permission: 'EDIT_STORE_ORDERING',
              description: 'Edit Store Ordering',
              moduleID: 32,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 15,
          name: 'Persona',
          description: 'Persona',
          order: 6,
          roleModulePermissions: [
            {
              id: 58,
              permission: 'DELETE_PERSONA',
              description: 'Delete Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 56,
              permission: 'VIEW_PERSONA',
              description: 'View Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 55,
              permission: 'CREATE_PERSONA',
              description: 'Create Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 57,
              permission: 'EDIT_PERSONA',
              description: 'Edit Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 21,
          name: 'Category',
          description: 'Category',
          order: 15,
          roleModulePermissions: [
            {
              id: 38,
              permission: 'EDIT_CATEGORY',
              description: 'Edit Category',
              moduleID: 21,
              active: true,
              deleted: false,
            },
            {
              id: 37,
              permission: 'VIEW_CATEGORY',
              description: 'View Categories',
              moduleID: 21,
              active: true,
              deleted: false,
            },
            {
              id: 39,
              permission: 'DELETE_CATEGORY',
              description: 'Delete Category',
              moduleID: 21,
              active: true,
              deleted: false,
            },
            {
              id: 36,
              permission: 'CREATE_CATEGORY',
              description: 'Create Category',
              moduleID: 21,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 25,
          name: 'Item',
          description: 'Item',
          order: 22,
          roleModulePermissions: [
            {
              id: 71,
              permission: 'CREATE_ITEM',
              description: 'Create Item',
              moduleID: 25,
              active: true,
              deleted: false,
            },
            {
              id: 72,
              permission: 'VIEW_ITEM',
              description: 'View Item',
              moduleID: 25,
              active: true,
              deleted: false,
            },
            {
              id: 73,
              permission: 'EDIT_ITEM',
              description: 'Edit Item',
              moduleID: 25,
              active: true,
              deleted: false,
            },
            {
              id: 74,
              permission: 'DELETE_ITEM',
              description: 'Delete Item',
              moduleID: 25,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 31,
          name: 'Merchant Ordering Setup',
          description: 'Merchant Ordering Setup',
          order: 8,
          roleModulePermissions: [
            {
              id: 77,
              permission: 'VIEW_MERCHANT_ORDERING',
              description: 'View Merchant Ordering',
              moduleID: 31,
              active: true,
              deleted: false,
            },
            {
              id: 78,
              permission: 'EDIT_MERCHANT_ORDERING',
              description: 'Edit Merchant Ordering',
              moduleID: 31,
              active: true,
              deleted: false,
            },
            {
              id: 79,
              permission: 'DELETE_MERCHANT_ORDERING',
              description: 'Delete Merchant Ordering',
              moduleID: 31,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 10,
          name: 'Program',
          description: 'Program',
          order: 2,
          roleModulePermissions: [
            {
              id: 29,
              permission: 'VIEW_PROGRAM',
              description: 'View Programs',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 30,
              permission: 'EDIT_PROGRAM',
              description: 'Edit Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 31,
              permission: 'DELETE_PROGRAM',
              description: 'Delete Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 28,
              permission: 'CREATE_PROGRAM',
              description: 'Create Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 41,
          name: 'Menu Import',
          description: 'Menu Import',
          order: 30,
          roleModulePermissions: [
            {
              id: 123,
              permission: 'MENU_IMPORT_FOR_SINGLE_LOCATION',
              description: 'Menu Import for Single Location',
              moduleID: 41,
              active: true,
              deleted: false,
            },
            {
              id: 121,
              permission: 'VIEW_MENU_IMPORT_HISTORY',
              description: 'View Menu Import History',
              moduleID: 41,
              active: true,
              deleted: false,
            },
            {
              id: 122,
              permission: 'MENU_IMPORT_FOR_LOCATIONS',
              description: 'Menu Import for Locations',
              moduleID: 41,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 42,
          name: 'ACH Portal',
          description: 'ACH Portal',
          order: 31,
          roleModulePermissions: [
            {
              id: 126,
              permission: 'ACH_PORTAL_ENROLL_LOCATION',
              description: 'ACH Portal Enroll Location',
              moduleID: 42,
              active: true,
              deleted: false,
            },
            {
              id: 125,
              permission: 'ACH_PORTAL_VIEW_POOL_ACCOUNT',
              description: 'ACH Portal View Pool Account',
              moduleID: 42,
              active: true,
              deleted: false,
            },
            {
              id: 127,
              permission: 'ACH_PORTAL_VIEW_TRANSACTION_HISTORY',
              description: 'ACH Portal View Transaction History',
              moduleID: 42,
              active: true,
              deleted: false,
            },
            {
              id: 124,
              permission: 'ACH_PORTAL_ACCESS',
              description: 'ACH Portal Access',
              moduleID: 42,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 14,
          name: 'Loyalty',
          description: 'Loyalty',
          order: 4,
          roleModulePermissions: [
            {
              id: 13,
              permission: 'DISTRIBUTE_LOYALTY_OFFERS',
              description: 'Distribute Loyalty Offers',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 11,
              permission: 'VIEW_LOYALTY_OFFER',
              description: 'View Loyalty Offers',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 14,
              permission: 'DELETE_LOYALTY_OFFER',
              description: 'Delete Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 10,
              permission: 'CREATE_LOYALTY_OFFER',
              description: 'Create Loyalty Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 12,
              permission: 'EDIT_LOYALTY_OFFER',
              description: 'Edit Loyalty Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 17,
          name: 'Merchant',
          description: 'Merchant',
          order: 7,
          roleModulePermissions: [
            {
              id: 23,
              permission: 'DELETE_MERCHANT',
              description: 'Delete Merchant',
              moduleID: 17,
              active: true,
              deleted: false,
            },
            {
              id: 22,
              permission: 'EDIT_MERCHANT',
              description: 'Edit Merchant',
              moduleID: 17,
              active: true,
              deleted: false,
            },
            {
              id: 21,
              permission: 'VIEW_MERCHANT',
              description: 'View Merchants',
              moduleID: 17,
              active: true,
              deleted: false,
            },
            {
              id: 20,
              permission: 'CREATE_MERCHANT',
              description: 'Create Merchant',
              moduleID: 17,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 22,
          name: 'Brand',
          description: 'Brand',
          order: 17,
          roleModulePermissions: [
            {
              id: 35,
              permission: 'DELETE_BRAND',
              description: 'Delete Brand',
              moduleID: 22,
              active: true,
              deleted: false,
            },
            {
              id: 33,
              permission: 'VIEW_BRAND',
              description: 'View Brands',
              moduleID: 22,
              active: true,
              deleted: false,
            },
            {
              id: 34,
              permission: 'EDIT_BRAND',
              description: 'Edit Brand',
              moduleID: 22,
              active: true,
              deleted: false,
            },
            {
              id: 32,
              permission: 'CREATE_BRAND',
              description: 'Create Brand',
              moduleID: 22,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 34,
          name: 'Support',
          description: 'Support',
          order: 27,
          roleModulePermissions: [
            {
              id: 87,
              permission: 'VIEW_SUPPORT',
              description: 'View Support',
              moduleID: 34,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 33,
          name: 'Customer Tags',
          description: 'Customer Tags',
          order: 18,
          roleModulePermissions: [
            {
              id: 86,
              permission: 'DELETE_EXTENSIBLE_ATTRIBUTES',
              description: 'Delete Customer Tags',
              moduleID: 33,
              active: true,
              deleted: false,
            },
            {
              id: 84,
              permission: 'CREATE_EXTENSIBLE_ATTRIBUTES',
              description: 'Create Customer Tags',
              moduleID: 33,
              active: true,
              deleted: false,
            },
            {
              id: 83,
              permission: 'VIEW_EXTENSIBLE_ATTRIBUTES',
              description: 'View Customer Tags',
              moduleID: 33,
              active: true,
              deleted: false,
            },
            {
              id: 85,
              permission: 'EDIT_EXTENSIBLE_ATTRIBUTES',
              description: 'Edit Customer Tags',
              moduleID: 33,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 16,
          name: 'Beacon',
          description: 'Beacon',
          order: 6,
          roleModulePermissions: [
            {
              id: 54,
              permission: 'VIEW_BEACON',
              description: 'View Beacon',
              moduleID: 16,
              active: true,
              deleted: false,
            },
            {
              id: 53,
              permission: 'DELETE_BEACON',
              description: 'Delete Beacon',
              moduleID: 16,
              active: true,
              deleted: false,
            },
            {
              id: 51,
              permission: 'CREATE_BEACON',
              description: 'Create Beacon',
              moduleID: 16,
              active: true,
              deleted: false,
            },
            {
              id: 52,
              permission: 'EDIT_BEACON',
              description: 'Edit Beacon',
              moduleID: 16,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 29,
          name: 'Loyalty Transaction',
          description: 'Loyalty Transaction',
          order: 26,
          roleModulePermissions: [
            {
              id: 40,
              permission: 'VIEW_LOYALTY_TRANSACTION',
              description: 'View Loyalty Transactions',
              moduleID: 29,
              active: true,
              deleted: false,
            },
            {
              id: 41,
              permission: 'EDIT_LOYALTY_TRANSACTION',
              description: 'Edit Loyalty Transaction',
              moduleID: 29,
              active: true,
              deleted: false,
            },
            {
              id: 42,
              permission: 'DELETE_LOYALTY_TRANSACTION',
              description: 'Delete Loyalty Transaction',
              moduleID: 29,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 26,
          name: 'Users',
          description: 'Users',
          order: 23,
          roleModulePermissions: [
            {
              id: 43,
              permission: 'CREATE_USER',
              description: 'Create User',
              moduleID: 26,
              active: true,
              deleted: false,
            },
            {
              id: 46,
              permission: 'DELETE_USER',
              description: 'Delete User',
              moduleID: 26,
              active: true,
              deleted: false,
            },
            {
              id: 45,
              permission: 'EDIT_USER',
              description: 'Edit User',
              moduleID: 26,
              active: true,
              deleted: false,
            },
            {
              id: 44,
              permission: 'VIEW_USER',
              description: 'View Users',
              moduleID: 26,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 23,
          name: 'Menu',
          description: 'Menu',
          order: 20,
          roleModulePermissions: [
            {
              id: 59,
              permission: 'CREATE_MENU',
              description: 'Create Menu',
              moduleID: 23,
              active: true,
              deleted: false,
            },
            {
              id: 62,
              permission: 'DELETE_MENU',
              description: 'Delete Menu',
              moduleID: 23,
              active: true,
              deleted: false,
            },
            {
              id: 60,
              permission: 'VIEW_MENU',
              description: 'View Menu',
              moduleID: 23,
              active: true,
              deleted: false,
            },
            {
              id: 61,
              permission: 'EDIT_MENU',
              description: 'Edit Menu',
              moduleID: 23,
              active: true,
              deleted: false,
            },
            {
              id: 108,
              permission: 'CACHE_MENU',
              description: 'Cache Menu',
              moduleID: 23,
              active: true,
              deleted: false,
            },
            {
              id: 107,
              permission: 'MENU_BUILDER',
              description: 'Menu Builder',
              moduleID: 23,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 2,
              permission: 'VIEW_MESSAGE',
              description: 'View Messages',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 131,
              permission: 'CONFIGURE_CLIENT',
              description: 'Configure Client (Incentivio only)',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 4,
              permission: 'DELETE_MESSAGE',
              description: 'Delete Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 3,
              permission: 'EDIT_MESSAGE',
              description: 'Edit Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
      ],
      active: true,
      deleted: false,
    },
    {
      id: 32,
      role: 'Admin New',
      description: 'new',
      modules: [
        {
          id: 14,
          name: 'Loyalty',
          description: 'Loyalty',
          order: 4,
          roleModulePermissions: [
            {
              id: 12,
              permission: 'EDIT_LOYALTY_OFFER',
              description: 'Edit Loyalty Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 13,
              permission: 'DISTRIBUTE_LOYALTY_OFFERS',
              description: 'Distribute Loyalty Offers',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 11,
              permission: 'VIEW_LOYALTY_OFFER',
              description: 'View Loyalty Offers',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 10,
              permission: 'CREATE_LOYALTY_OFFER',
              description: 'Create Loyalty Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 11,
          name: 'Campaign',
          description: 'Campaign',
          order: 2,
          roleModulePermissions: [
            {
              id: 17,
              permission: 'EDIT_CAMPAIGN',
              description: 'Edit Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 18,
              permission: 'DELETE_CAMPAIGN',
              description: 'Delete Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 15,
              permission: 'CREATE_CAMPAIGN',
              description: 'Create Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 16,
              permission: 'VIEW_CAMPAIGN',
              description: 'View Campaigns',
              moduleID: 11,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 19,
              permission: 'VIEW_DASHBOARD',
              description: 'View Dashboard',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 150,
              permission: 'VIEW_SALES_SUMMARY',
              description: 'View Sales Summary',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 75,
              permission: 'VIEW_ORDERS',
              description: 'View Orders',
              moduleID: 9,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 15,
          name: 'Persona',
          description: 'Persona',
          order: 6,
          roleModulePermissions: [
            {
              id: 57,
              permission: 'EDIT_PERSONA',
              description: 'Edit Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 58,
              permission: 'DELETE_PERSONA',
              description: 'Delete Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 56,
              permission: 'VIEW_PERSONA',
              description: 'View Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 55,
              permission: 'CREATE_PERSONA',
              description: 'Create Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 13,
          name: 'Offers',
          description: 'Offers',
          order: 3,
          roleModulePermissions: [
            {
              id: 9,
              permission: 'DELETE_OFFER',
              description: 'Delete Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 6,
              permission: 'VIEW_OFFER',
              description: 'View Offers',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 8,
              permission: 'DISTRIBUTE_OFFERS',
              description: 'Distribute Offers',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 7,
              permission: 'EDIT_OFFER',
              description: 'Edit Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 5,
              permission: 'CREATE_OFFER',
              description: 'Create Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 16,
          name: 'Beacon',
          description: 'Beacon',
          order: 6,
          roleModulePermissions: [
            {
              id: 51,
              permission: 'CREATE_BEACON',
              description: 'Create Beacon',
              moduleID: 16,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 10,
          name: 'Program',
          description: 'Program',
          order: 2,
          roleModulePermissions: [
            {
              id: 29,
              permission: 'VIEW_PROGRAM',
              description: 'View Programs',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 30,
              permission: 'EDIT_PROGRAM',
              description: 'Edit Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 31,
              permission: 'DELETE_PROGRAM',
              description: 'Delete Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 28,
              permission: 'CREATE_PROGRAM',
              description: 'Create Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 4,
              permission: 'DELETE_MESSAGE',
              description: 'Delete Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 3,
              permission: 'EDIT_MESSAGE',
              description: 'Edit Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 2,
              permission: 'VIEW_MESSAGE',
              description: 'View Messages',
              moduleID: 12,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
      ],
      active: true,
      deleted: false,
    },
    {
      id: 6,
      role: 'Admin124',
      description: 'asdasd',
      modules: [
        {
          id: 35,
          name: 'Survey',
          description: 'Survey',
          order: 9,
          roleModulePermissions: [
            {
              id: 88,
              permission: 'VIEW_SURVEY',
              description: 'View Survey',
              moduleID: 35,
              active: true,
              deleted: false,
            },
            {
              id: 90,
              permission: 'DELETE_SURVEY',
              description: 'Delete Survey',
              moduleID: 35,
              active: true,
              deleted: false,
            },
            {
              id: 91,
              permission: 'CREATE_SURVEY',
              description: 'Create Survey',
              moduleID: 35,
              active: true,
              deleted: false,
            },
            {
              id: 89,
              permission: 'EDIT_SURVEY',
              description: 'Edit Survey',
              moduleID: 35,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 37,
          name: 'Customers',
          description: 'Customers',
          order: 11,
          roleModulePermissions: [
            {
              id: 96,
              permission: 'VIEW_CUSTOMER',
              description: 'View Customer',
              moduleID: 37,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 27,
          name: 'Roles',
          description: 'Roles',
          order: 24,
          roleModulePermissions: [
            {
              id: 49,
              permission: 'EDIT_ROLE',
              description: 'Edit Role',
              moduleID: 27,
              active: true,
              deleted: false,
            },
            {
              id: 50,
              permission: 'DELETE_ROLE',
              description: 'Delete Role',
              moduleID: 27,
              active: true,
              deleted: false,
            },
            {
              id: 48,
              permission: 'VIEW_ROLE',
              description: 'View Roles',
              moduleID: 27,
              active: true,
              deleted: false,
            },
            {
              id: 47,
              permission: 'CREATE_ROLE',
              description: 'Create Role',
              moduleID: 27,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 19,
              permission: 'VIEW_DASHBOARD',
              description: 'View Dashboard',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              active: true,
              deleted: false,
            },
            {
              id: 75,
              permission: 'VIEW_ORDERS',
              description: 'View Orders',
              moduleID: 9,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 24,
          name: 'Group',
          description: 'Group',
          order: 21,
          roleModulePermissions: [
            {
              id: 65,
              permission: 'EDIT_GROUP',
              description: 'Edit Group',
              moduleID: 24,
              active: true,
              deleted: false,
            },
            {
              id: 64,
              permission: 'VIEW_GROUP',
              description: 'View Group',
              moduleID: 24,
              active: true,
              deleted: false,
            },
            {
              id: 63,
              permission: 'CREATE_GROUP',
              description: 'Create Group',
              moduleID: 24,
              active: true,
              deleted: false,
            },
            {
              id: 66,
              permission: 'DELETE_GROUP',
              description: 'Delete Group',
              moduleID: 24,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 13,
          name: 'Offers',
          description: 'Offers',
          order: 3,
          roleModulePermissions: [
            {
              id: 5,
              permission: 'CREATE_OFFER',
              description: 'Create Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 6,
              permission: 'VIEW_OFFER',
              description: 'View Offers',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 9,
              permission: 'DELETE_OFFER',
              description: 'Delete Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 8,
              permission: 'DISTRIBUTE_OFFERS',
              description: 'Distribute Offers',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 7,
              permission: 'EDIT_OFFER',
              description: 'Edit Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 38,
          name: 'Easy Order',
          description: 'Easy Order',
          order: 19,
          roleModulePermissions: [
            {
              id: 100,
              permission: 'EDIT_EASY_ORDER',
              description: 'Edit Easy Order',
              moduleID: 38,
              active: true,
              deleted: false,
            },
            {
              id: 102,
              permission: 'CREATE_EASY_ORDER',
              description: 'Create Easy Order',
              moduleID: 38,
              active: true,
              deleted: false,
            },
            {
              id: 99,
              permission: 'VIEW_EASY_ORDER',
              description: 'View Easy Order',
              moduleID: 38,
              active: true,
              deleted: false,
            },
            {
              id: 101,
              permission: 'DELETE_EASY_ORDER',
              description: 'Delete Easy Order',
              moduleID: 38,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 39,
          name: 'Promo Code',
          description: 'Promo Code',
          order: 28,
          roleModulePermissions: [
            {
              id: 105,
              permission: 'VIEW_PROMO_CODE',
              description: 'View Promo Code',
              moduleID: 39,
              active: true,
              deleted: false,
            },
            {
              id: 106,
              permission: 'DELETE_PROMO_CODE',
              description: 'Delete Promo Code',
              moduleID: 39,
              active: true,
              deleted: false,
            },
            {
              id: 103,
              permission: 'CREATE_PROMO_CODE',
              description: 'Create Promo Code',
              moduleID: 39,
              active: true,
              deleted: false,
            },
            {
              id: 104,
              permission: 'EDIT_PROMO_CODE',
              description: 'Edit Promo Code',
              moduleID: 39,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 36,
          name: 'Survey Question',
          description: 'Survey Question',
          order: 10,
          roleModulePermissions: [
            {
              id: 95,
              permission: 'CREATE_SURVEY_QUESTION',
              description: 'Create Survey Question',
              moduleID: 36,
              active: true,
              deleted: false,
            },
            {
              id: 94,
              permission: 'DELETE_SURVEY_QUESTION',
              description: 'Delete Survey Question',
              moduleID: 36,
              active: true,
              deleted: false,
            },
            {
              id: 92,
              permission: 'VIEW_SURVEY_QUESTION',
              description: 'View Survey Question',
              moduleID: 36,
              active: true,
              deleted: false,
            },
            {
              id: 93,
              permission: 'EDIT_SURVEY_QUESTION',
              description: 'Edit Survey Question',
              moduleID: 36,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 40,
          name: 'Gift Card',
          description: 'Gift Card',
          order: 29,
          roleModulePermissions: [
            {
              id: 119,
              permission: 'COMP_ADD_VALUE_GIFT_CARD',
              description: 'Comp Add Value',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 112,
              permission: 'ACTIVATE_GIFT_CARD',
              description: 'Activate Gift Card',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 113,
              permission: 'DEACTIVATE_GIFT_CARD',
              description: 'Deactivate Gift Card',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 115,
              permission: 'GENERATE_GIFT_CARDS',
              description: 'Generate Gift Cards',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 118,
              permission: 'RESEND_GIFT_CARD_EMAIL',
              description: 'Resend Gift Card Email',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 111,
              permission: 'RESET_BALANCE_GIFT_CARD',
              description: 'Reset Gift Card Balance',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 114,
              permission: 'IMPORT_GIFT_CARDS',
              description: 'Import Gift Cards',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 120,
              permission: 'COMP_GIFT_CARD',
              description: 'Comp Gift Card',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 117,
              permission: 'VIEW_GIFT_CARD_POOL_REPORT',
              description: 'View Gift Card Pool Report',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 109,
              permission: 'VIEW_GIFT_CARD',
              description: 'View Gift Card',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 110,
              permission: 'REMOVE_VALUE_GIFT_CARD',
              description: 'Remove Value From Gift Card',
              moduleID: 40,
              active: true,
              deleted: false,
            },
            {
              id: 116,
              permission: 'VIEW_GIFT_ANALYTICS',
              description: 'View Gift Analytics',
              moduleID: 40,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 11,
          name: 'Campaign',
          description: 'Campaign',
          order: 2,
          roleModulePermissions: [
            {
              id: 16,
              permission: 'VIEW_CAMPAIGN',
              description: 'View Campaigns',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 18,
              permission: 'DELETE_CAMPAIGN',
              description: 'Delete Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 17,
              permission: 'EDIT_CAMPAIGN',
              description: 'Edit Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 15,
              permission: 'CREATE_CAMPAIGN',
              description: 'Create Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 19,
          name: 'Store',
          description: 'Store',
          order: 12,
          roleModulePermissions: [
            {
              id: 26,
              permission: 'EDIT_STORE',
              description: 'Edit Store',
              moduleID: 19,
              active: true,
              deleted: false,
            },
            {
              id: 27,
              permission: 'DELETE_STORE',
              description: 'Delete Store',
              moduleID: 19,
              active: true,
              deleted: false,
            },
            {
              id: 25,
              permission: 'VIEW_STORE',
              description: 'View Stores',
              moduleID: 19,
              active: true,
              deleted: false,
            },
            {
              id: 24,
              permission: 'CREATE_STORE',
              description: 'Create Store',
              moduleID: 19,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 32,
          name: 'Store Ordering Setup',
          description: 'Store Ordering Setup',
          order: 13,
          roleModulePermissions: [
            {
              id: 80,
              permission: 'VIEW_STORE_ORDERING',
              description: 'View Store Ordering',
              moduleID: 32,
              active: true,
              deleted: false,
            },
            {
              id: 82,
              permission: 'DELETE_STORE_ORDERING',
              description: 'Delete Store Ordering',
              moduleID: 32,
              active: true,
              deleted: false,
            },
            {
              id: 81,
              permission: 'EDIT_STORE_ORDERING',
              description: 'Edit Store Ordering',
              moduleID: 32,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 15,
          name: 'Persona',
          description: 'Persona',
          order: 6,
          roleModulePermissions: [
            {
              id: 55,
              permission: 'CREATE_PERSONA',
              description: 'Create Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 58,
              permission: 'DELETE_PERSONA',
              description: 'Delete Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 57,
              permission: 'EDIT_PERSONA',
              description: 'Edit Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 56,
              permission: 'VIEW_PERSONA',
              description: 'View Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 21,
          name: 'Category',
          description: 'Category',
          order: 15,
          roleModulePermissions: [
            {
              id: 39,
              permission: 'DELETE_CATEGORY',
              description: 'Delete Category',
              moduleID: 21,
              active: true,
              deleted: false,
            },
            {
              id: 38,
              permission: 'EDIT_CATEGORY',
              description: 'Edit Category',
              moduleID: 21,
              active: true,
              deleted: false,
            },
            {
              id: 37,
              permission: 'VIEW_CATEGORY',
              description: 'View Categories',
              moduleID: 21,
              active: true,
              deleted: false,
            },
            {
              id: 36,
              permission: 'CREATE_CATEGORY',
              description: 'Create Category',
              moduleID: 21,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 25,
          name: 'Item',
          description: 'Item',
          order: 22,
          roleModulePermissions: [
            {
              id: 72,
              permission: 'VIEW_ITEM',
              description: 'View Item',
              moduleID: 25,
              active: true,
              deleted: false,
            },
            {
              id: 73,
              permission: 'EDIT_ITEM',
              description: 'Edit Item',
              moduleID: 25,
              active: true,
              deleted: false,
            },
            {
              id: 71,
              permission: 'CREATE_ITEM',
              description: 'Create Item',
              moduleID: 25,
              active: true,
              deleted: false,
            },
            {
              id: 74,
              permission: 'DELETE_ITEM',
              description: 'Delete Item',
              moduleID: 25,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 31,
          name: 'Merchant Ordering Setup',
          description: 'Merchant Ordering Setup',
          order: 8,
          roleModulePermissions: [
            {
              id: 78,
              permission: 'EDIT_MERCHANT_ORDERING',
              description: 'Edit Merchant Ordering',
              moduleID: 31,
              active: true,
              deleted: false,
            },
            {
              id: 77,
              permission: 'VIEW_MERCHANT_ORDERING',
              description: 'View Merchant Ordering',
              moduleID: 31,
              active: true,
              deleted: false,
            },
            {
              id: 79,
              permission: 'DELETE_MERCHANT_ORDERING',
              description: 'Delete Merchant Ordering',
              moduleID: 31,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 41,
          name: 'Menu Import',
          description: 'Menu Import',
          order: 30,
          roleModulePermissions: [
            {
              id: 123,
              permission: 'MENU_IMPORT_FOR_SINGLE_LOCATION',
              description: 'Menu Import for Single Location',
              moduleID: 41,
              active: true,
              deleted: false,
            },
            {
              id: 122,
              permission: 'MENU_IMPORT_FOR_LOCATIONS',
              description: 'Menu Import for Locations',
              moduleID: 41,
              active: true,
              deleted: false,
            },
            {
              id: 121,
              permission: 'VIEW_MENU_IMPORT_HISTORY',
              description: 'View Menu Import History',
              moduleID: 41,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 10,
          name: 'Program',
          description: 'Program',
          order: 2,
          roleModulePermissions: [
            {
              id: 28,
              permission: 'CREATE_PROGRAM',
              description: 'Create Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 29,
              permission: 'VIEW_PROGRAM',
              description: 'View Programs',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 31,
              permission: 'DELETE_PROGRAM',
              description: 'Delete Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 30,
              permission: 'EDIT_PROGRAM',
              description: 'Edit Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 14,
          name: 'Loyalty',
          description: 'Loyalty',
          order: 4,
          roleModulePermissions: [
            {
              id: 12,
              permission: 'EDIT_LOYALTY_OFFER',
              description: 'Edit Loyalty Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 13,
              permission: 'DISTRIBUTE_LOYALTY_OFFERS',
              description: 'Distribute Loyalty Offers',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 10,
              permission: 'CREATE_LOYALTY_OFFER',
              description: 'Create Loyalty Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 14,
              permission: 'DELETE_LOYALTY_OFFER',
              description: 'Delete Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
            {
              id: 11,
              permission: 'VIEW_LOYALTY_OFFER',
              description: 'View Loyalty Offers',
              moduleID: 14,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 17,
          name: 'Merchant',
          description: 'Merchant',
          order: 7,
          roleModulePermissions: [
            {
              id: 22,
              permission: 'EDIT_MERCHANT',
              description: 'Edit Merchant',
              moduleID: 17,
              active: true,
              deleted: false,
            },
            {
              id: 23,
              permission: 'DELETE_MERCHANT',
              description: 'Delete Merchant',
              moduleID: 17,
              active: true,
              deleted: false,
            },
            {
              id: 21,
              permission: 'VIEW_MERCHANT',
              description: 'View Merchants',
              moduleID: 17,
              active: true,
              deleted: false,
            },
            {
              id: 20,
              permission: 'CREATE_MERCHANT',
              description: 'Create Merchant',
              moduleID: 17,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 34,
          name: 'Support',
          description: 'Support',
          order: 27,
          roleModulePermissions: [
            {
              id: 87,
              permission: 'VIEW_SUPPORT',
              description: 'View Support',
              moduleID: 34,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 22,
          name: 'Brand',
          description: 'Brand',
          order: 17,
          roleModulePermissions: [
            {
              id: 34,
              permission: 'EDIT_BRAND',
              description: 'Edit Brand',
              moduleID: 22,
              active: true,
              deleted: false,
            },
            {
              id: 32,
              permission: 'CREATE_BRAND',
              description: 'Create Brand',
              moduleID: 22,
              active: true,
              deleted: false,
            },
            {
              id: 33,
              permission: 'VIEW_BRAND',
              description: 'View Brands',
              moduleID: 22,
              active: true,
              deleted: false,
            },
            {
              id: 35,
              permission: 'DELETE_BRAND',
              description: 'Delete Brand',
              moduleID: 22,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 33,
          name: 'Customer Tags',
          description: 'Customer Tags',
          order: 18,
          roleModulePermissions: [
            {
              id: 86,
              permission: 'DELETE_EXTENSIBLE_ATTRIBUTES',
              description: 'Delete Customer Tags',
              moduleID: 33,
              active: true,
              deleted: false,
            },
            {
              id: 83,
              permission: 'VIEW_EXTENSIBLE_ATTRIBUTES',
              description: 'View Customer Tags',
              moduleID: 33,
              active: true,
              deleted: false,
            },
            {
              id: 85,
              permission: 'EDIT_EXTENSIBLE_ATTRIBUTES',
              description: 'Edit Customer Tags',
              moduleID: 33,
              active: true,
              deleted: false,
            },
            {
              id: 84,
              permission: 'CREATE_EXTENSIBLE_ATTRIBUTES',
              description: 'Create Customer Tags',
              moduleID: 33,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 16,
          name: 'Beacon',
          description: 'Beacon',
          order: 6,
          roleModulePermissions: [
            {
              id: 53,
              permission: 'DELETE_BEACON',
              description: 'Delete Beacon',
              moduleID: 16,
              active: true,
              deleted: false,
            },
            {
              id: 52,
              permission: 'EDIT_BEACON',
              description: 'Edit Beacon',
              moduleID: 16,
              active: true,
              deleted: false,
            },
            {
              id: 51,
              permission: 'CREATE_BEACON',
              description: 'Create Beacon',
              moduleID: 16,
              active: true,
              deleted: false,
            },
            {
              id: 54,
              permission: 'VIEW_BEACON',
              description: 'View Beacon',
              moduleID: 16,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 29,
          name: 'Loyalty Transaction',
          description: 'Loyalty Transaction',
          order: 26,
          roleModulePermissions: [
            {
              id: 42,
              permission: 'DELETE_LOYALTY_TRANSACTION',
              description: 'Delete Loyalty Transaction',
              moduleID: 29,
              active: true,
              deleted: false,
            },
            {
              id: 41,
              permission: 'EDIT_LOYALTY_TRANSACTION',
              description: 'Edit Loyalty Transaction',
              moduleID: 29,
              active: true,
              deleted: false,
            },
            {
              id: 40,
              permission: 'VIEW_LOYALTY_TRANSACTION',
              description: 'View Loyalty Transactions',
              moduleID: 29,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 26,
          name: 'Users',
          description: 'Users',
          order: 23,
          roleModulePermissions: [
            {
              id: 45,
              permission: 'EDIT_USER',
              description: 'Edit User',
              moduleID: 26,
              active: true,
              deleted: false,
            },
            {
              id: 46,
              permission: 'DELETE_USER',
              description: 'Delete User',
              moduleID: 26,
              active: true,
              deleted: false,
            },
            {
              id: 43,
              permission: 'CREATE_USER',
              description: 'Create User',
              moduleID: 26,
              active: true,
              deleted: false,
            },
            {
              id: 44,
              permission: 'VIEW_USER',
              description: 'View Users',
              moduleID: 26,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 23,
          name: 'Menu',
          description: 'Menu',
          order: 20,
          roleModulePermissions: [
            {
              id: 108,
              permission: 'CACHE_MENU',
              description: 'Cache Menu',
              moduleID: 23,
              active: true,
              deleted: false,
            },
            {
              id: 59,
              permission: 'CREATE_MENU',
              description: 'Create Menu',
              moduleID: 23,
              active: true,
              deleted: false,
            },
            {
              id: 61,
              permission: 'EDIT_MENU',
              description: 'Edit Menu',
              moduleID: 23,
              active: true,
              deleted: false,
            },
            {
              id: 62,
              permission: 'DELETE_MENU',
              description: 'Delete Menu',
              moduleID: 23,
              active: true,
              deleted: false,
            },
            {
              id: 107,
              permission: 'MENU_BUILDER',
              description: 'Menu Builder',
              moduleID: 23,
              active: true,
              deleted: false,
            },
            {
              id: 60,
              permission: 'VIEW_MENU',
              description: 'View Menu',
              moduleID: 23,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 2,
              permission: 'VIEW_MESSAGE',
              description: 'View Messages',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 3,
              permission: 'EDIT_MESSAGE',
              description: 'Edit Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 4,
              permission: 'DELETE_MESSAGE',
              description: 'Delete Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
      ],
      active: true,
      deleted: false,
    },
    {
      id: 12,
      role: 'All Babies Cry User',
      description: null,
      modules: [
        {
          id: 17,
          name: 'Merchant',
          description: 'Merchant',
          order: 7,
          roleModulePermissions: [
            {
              id: 20,
              permission: 'CREATE_MERCHANT',
              description: 'Create Merchant',
              moduleID: 17,
              active: true,
              deleted: false,
            },
            {
              id: 23,
              permission: 'DELETE_MERCHANT',
              description: 'Delete Merchant',
              moduleID: 17,
              active: true,
              deleted: false,
            },
            {
              id: 22,
              permission: 'EDIT_MERCHANT',
              description: 'Edit Merchant',
              moduleID: 17,
              active: true,
              deleted: false,
            },
            {
              id: 21,
              permission: 'VIEW_MERCHANT',
              description: 'View Merchants',
              moduleID: 17,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 11,
          name: 'Campaign',
          description: 'Campaign',
          order: 2,
          roleModulePermissions: [
            {
              id: 15,
              permission: 'CREATE_CAMPAIGN',
              description: 'Create Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 18,
              permission: 'DELETE_CAMPAIGN',
              description: 'Delete Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 16,
              permission: 'VIEW_CAMPAIGN',
              description: 'View Campaigns',
              moduleID: 11,
              active: true,
              deleted: false,
            },
            {
              id: 17,
              permission: 'EDIT_CAMPAIGN',
              description: 'Edit Campaign',
              moduleID: 11,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 15,
          name: 'Persona',
          description: 'Persona',
          order: 6,
          roleModulePermissions: [
            {
              id: 57,
              permission: 'EDIT_PERSONA',
              description: 'Edit Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 56,
              permission: 'VIEW_PERSONA',
              description: 'View Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 55,
              permission: 'CREATE_PERSONA',
              description: 'Create Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
            {
              id: 58,
              permission: 'DELETE_PERSONA',
              description: 'Delete Persona',
              moduleID: 15,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 19,
              permission: 'VIEW_DASHBOARD',
              description: 'View Dashboard',
              moduleID: 9,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 13,
          name: 'Offers',
          description: 'Offers',
          order: 3,
          roleModulePermissions: [
            {
              id: 6,
              permission: 'VIEW_OFFER',
              description: 'View Offers',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 7,
              permission: 'EDIT_OFFER',
              description: 'Edit Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 9,
              permission: 'DELETE_OFFER',
              description: 'Delete Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
            {
              id: 5,
              permission: 'CREATE_OFFER',
              description: 'Create Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 10,
          name: 'Program',
          description: 'Program',
          order: 2,
          roleModulePermissions: [
            {
              id: 30,
              permission: 'EDIT_PROGRAM',
              description: 'Edit Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 28,
              permission: 'CREATE_PROGRAM',
              description: 'Create Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 29,
              permission: 'VIEW_PROGRAM',
              description: 'View Programs',
              moduleID: 10,
              active: true,
              deleted: false,
            },
            {
              id: 31,
              permission: 'DELETE_PROGRAM',
              description: 'Delete Program',
              moduleID: 10,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 4,
              permission: 'DELETE_MESSAGE',
              description: 'Delete Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 2,
              permission: 'VIEW_MESSAGE',
              description: 'View Messages',
              moduleID: 12,
              active: true,
              deleted: false,
            },
            {
              id: 3,
              permission: 'EDIT_MESSAGE',
              description: 'Edit Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
      ],
      active: true,
      deleted: false,
    },
    {
      id: 21,
      role: 'Beta Dashboard User',
      description:
        'Beta Dashboard User - Should be able to access only Charts V2',
      modules: [
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
      ],
      active: true,
      deleted: false,
    },
    {
      id: 23,
      role: 'Customer Only',
      description: null,
      modules: [
        {
          id: 37,
          name: 'Customers',
          description: 'Customers',
          order: 11,
          roleModulePermissions: [
            {
              id: 96,
              permission: 'VIEW_CUSTOMER',
              description: 'View Customer',
              moduleID: 37,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
      ],
      active: true,
      deleted: false,
    },
    {
      id: 22,
      role: 'Customer Search',
      description: 'Customer Search with Offer distribution',
      modules: [
        {
          id: 37,
          name: 'Customers',
          description: 'Customers',
          order: 11,
          roleModulePermissions: [
            {
              id: 96,
              permission: 'VIEW_CUSTOMER',
              description: 'View Customer',
              moduleID: 37,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 14,
          name: 'Loyalty',
          description: 'Loyalty',
          order: 4,
          roleModulePermissions: [
            {
              id: 14,
              permission: 'DELETE_LOYALTY_OFFER',
              description: 'Delete Offer',
              moduleID: 14,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
      ],
      active: true,
      deleted: false,
    },
    {
      id: 20,
      role: 'DailySales',
      description: 'DailySales',
      modules: [
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 13,
          name: 'Offers',
          description: 'Offers',
          order: 3,
          roleModulePermissions: [
            {
              id: 5,
              permission: 'CREATE_OFFER',
              description: 'Create Offer',
              moduleID: 13,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
      ],
      active: true,
      deleted: false,
    },
  ],
};
